import React, { ReactNode } from 'react'
import useIsOverflow from 'hooks/useIsOverflow'
import { Box, BoxProps, CSSObject, TooltipProps } from '@mui/material'
import CustomTooltip from 'components/shared/CustomTooltip'

interface Props extends BoxProps {
  maxWidth: CSSObject['maxWidth']
  //   children: JSX.Element
  children: ReactNode
  label?: string | ReactNode
  TooltipProps?: Partial<TooltipProps>
}

export const OverflowTypography = React.forwardRef<HTMLElement, Props>(
  function OverflowTypography(props, ref) {
    const boxRef = React.useRef<HTMLElement>()

    const { maxWidth, label, children, TooltipProps, ...rest } = props
    const { isOverflow } = useIsOverflow(ref ? ref : boxRef, [])
    const displayLabel = label ? label : ''
    return (
      <CustomTooltip title={isOverflow ? displayLabel : ''} {...TooltipProps}>
        <Box
          ref={boxRef}
          maxWidth={maxWidth}
          textOverflow="ellipsis"
          overflow={'hidden'}
          whiteSpace="nowrap"
          {...rest}
        >
          {children}
        </Box>
      </CustomTooltip>
    )
  }
)
export default OverflowTypography
